import type { API, TRequestsHandler } from '~/utils/requestsProcessor/types';

export class JackpotImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /jackpot/{seasonYear}/positions-rewards */
  public getJackpotBySeasonYearPositionsRewards(seasonYear: number) {
    return this.makeRequest<API.GetPositionsRewardsByJackpotModel | undefined>(
      `jackpot/${encodeURIComponent(String(seasonYear))}/positions-rewards`,
      {
        method: 'GET'
      }
    );
  }

  /** GET /jackpot/{seasonYear}/user-scores */
  public getJackpotBySeasonYearUserScores(seasonYear: string) {
    return this.makeRequest<API.GetUserScoresByYearIndexModel[]>(
      `jackpot/${encodeURIComponent(String(seasonYear))}/user-scores`,
      {
        method: 'GET'
      }
    );
  }
}
